import React, {useState} from 'react';
import useCustomForm from "../../../services/useCustomForm";
import {CFormGroup, CInput, CLabel} from "@coreui/react";
import Form, {FormApi} from "../../../components/form";
import {TypeGroupTestList} from "./index";
import Select from "react-select";


const GroupTesteForm = () => {

    const initialValues: any = {
        id: null,
        name: '',
        type: '',
    }


    const {
        values,
        handleChange,
        handleSubmit,
        handleSubmitValues,
        setValues
    } = useCustomForm(
        {
            initialValues,
            route: 'group-teste',
            onSubmit: values => submitValues(values.values),
        }
    );
    const [, setFormApi] = useState<FormApi>();

    const handleChangeType = (option: any) => {
        setValues({...values, type: option ? option.value : ''});
    }

    const submitValues = (values: any,) => {
        handleSubmitValues(values);
    }

    const handleFormReady = (formApi: FormApi) => {
        setFormApi(formApi);
    }

    return (
        <Form entity={'Grupo de Teste ' + values.id} handleSubmit={handleSubmit} onFormReady={handleFormReady}>
            <CFormGroup>
                <CLabel className={'text-danger'} htmlFor="name">Nome do grupo de teste</CLabel>
                <CInput type="text" id="name" name="name" maxLength={250} onChange={handleChange} value={values.name}
                        required/>
            </CFormGroup>
            <CFormGroup>
                <CLabel className={'text-danger'} htmlFor="tipoGrupo">Tipo do grupo</CLabel>
                <Select
                    inputId="tipoGrupo"
                    options={TypeGroupTestList}
                    placeholder={'Selecione o tipo'}
                    value={TypeGroupTestList.find((item: any) => item.value == values.type) || null}
                    onChange={handleChangeType}
                    closeMenuOnSelect={true}
                    className={'filtro-select'}
                ></Select>
                <small className="text-muted">
                    Grupos de "Casos de Teste" podem ser usados para incluir vários casos de uma vez no plano de execução.
                </small>
            </CFormGroup>
        </Form>
    )
}

export default GroupTesteForm;
